import React from 'react';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import DEFAULT_FILLED_INPUT_CLASS_NAME from '../../theme/constants/filled-input';

const EmailField = ({ InputProps, ...props }) => {
  const [field, meta] = useField('email');

  return (
    <TextField
      {...field}
      name="email"
      placeholder="Correo Electrónico"
      variant="filled"
      fullWidth
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : null}
      InputProps={{ ...InputProps,
        className: InputProps?.className || DEFAULT_FILLED_INPUT_CLASS_NAME }}
      {...props}
    />
  );
};

export default EmailField;

EmailField.propTypes = {
  InputProps: PropTypes.shape({
    className: PropTypes.string,
  }),
};

EmailField.defaultProps = {
  InputProps: {},
};
